import { IconOptions } from 'leaflet';

export enum MarkerType {
  Start = 'start',
  End = 'end',
  CustomDefault = 'CustomDefault',
  Poi = 'Poi',
}

export enum MapShapeType {
  Circle = 'circle',
  Polygon = 'polygon',
}

export enum MapSetting {
  AssetsPageMap = 'AssetsPageMap',
  AssetsGridMap = 'AssetsGridMap',
  FleetMap = 'FleetMap',
  OnCallMap = 'OnCallMap',
  VehiclesPageMap = 'VehiclesPageMap1',
  VehiclesGridMap = 'VehiclesGridMap',
}

export const startIconPreset = {
  iconUrl: './assets/start.svg',
  iconSize: [20, 20],
} as IconOptions;

export const endIconPreset = {
  iconUrl: './assets/end.svg',
  iconSize: [20, 20],
} as IconOptions;

export const markerIconPreset = {
  iconUrl: './assets/map-marker-default.svg',
  iconSize: [36, 47],
} as IconOptions;
